import __ from './localization';
import { pageRenderPaths } from '../features/questions/common/telemetry';

export const report = {
  report: function (title, message, level, hideContent) {
    if (!title && !message) {
      // There is nothing to display.
      return;
    }

    var levels = ['info', 'success', 'warning', 'error'];

    if (levels.indexOf[level] === -1) {
      level = 'info';
    }

    $('#pageLoad').hide();
    $('#mainNav').hide();
    $('.spd-content').hide();

    if (hideContent) {
      $('#main_cont').hide();
    }

    var titleHtml = title ? '<h4>' + title + '</h4>' : '';
    var messageHtml = message ? '<p>' + message + '</p>' : '';

    $('#notification')
      .attr('class', 'alert alert-' + level)
      .html(titleHtml + messageHtml)
      .show();
  },
  info: function (title, message, hideContent) {
    this.report(title, message, 'info', hideContent);
  },
  success: function (title, message, hideContent) {
    this.report(title, message, 'success', hideContent);
  },
  warning: function (title, message, hideContent) {
    this.report(title, message, 'warning', hideContent);
  },
  error: function (title, message, hideContent) {
    this.report(title, message, 'error', hideContent);
  },
  /**
   * Extra New Relic attributes arrive either as `attributes` or, where the
   * call must stay two-arg (e.g. `reportChunkLoadFailure`), as
   * `error.telemetryAttributes`. Core errinfo keys always win.
   */
  logError: function (error, silent = false, attributes) {
    if (window.newrelic) {
      //selective supressing the following error
      var shouldIgnoreError = function (error) {
        var knownErrorToSuppress = [
          'privateSpecialRepair is not defined',
          'pollfish',
        ];
        return knownErrorToSuppress.some(function (knownError) {
          var regEx = new RegExp(knownError, 'gi');
          return regEx.test(error);
        });
      };

      newrelic.setErrorHandler(function (error) {
        if (shouldIgnoreError(error)) return true;
        return false;
      });
    }

    function getNestedProp(obj, path, defaultValue = '') {
      return path.reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : defaultValue),
        obj
      );
    }

    try {
      if (error && error.message.indexOf('ajax') === -1) {
        var errinfo = {
          // Error details
          'Error Message': error?.message || '',
          'Error Name': error?.name || '',
          // JSC environments (iOS) don't always include the message in the stack,
          // so we check and format accordingly
          'Error Stack':
            error?.stack &&
            error?.name &&
            error?.message &&
            !error.stack.includes(error.name) &&
            !error.stack.includes(error.message)
              ? error.name + ': ' + error.message + '\n' + error.stack
              : error?.stack || '',
          'Error Type': error?.type || '',
          'Error Code': error?.code || '',
          'Error Cause': error?.cause || '',
          'Error Filename': error?.fileName || '',

          // Nested error cause details
          'Error Cause Nested Message': getNestedProp(error, [
            'error',
            'cause',
            'message',
          ]),
          'Error Cause Nested Stack': getNestedProp(error, [
            'error',
            'cause',
            'stack',
          ]),
          'Error Cause Message': error?.cause?.message || '',
          'Error Cause Stack': error?.cause?.stack || '',
          'Error Nested': error?.error || '',
          'Error Nested Stack': error?.error?.stack || '',

          // Page and browser-related info
          URL: error?.url || window?.location?.href,
          'Line No': error?.lineNumber || '',
          'Column No': error?.columnNumber || '',

          // Custom data
          Silent: silent ? 'yes' : 'no',
          'Page Name': window?.page_state?.this_page || '',
          UUID: window?.page_state?.uuid || '',
          'Tracking Data': window?.page_state?.tracking_data || '',
          Referrer: document?.referrer || '',

          // Viewport information
          'Viewport Width': window?.innerWidth || '',
          'Viewport Height': window?.innerHeight || '',
          'Screen Orientation': screen?.orientation?.type || '',
        };

        // If Error contains a cause, append to the
        // errinfo object for New Relic tracking
        // and potential IVWBot notifications
        const cause = error?.cause || error?.error?.cause;
        if (cause && cause !== '') {
          errinfo[cause] = true;
        }

        if (!segments) {
          segments = /preview/.test(window.location.pathname)
            ? window.location.pathname.replace('/preview', '')
            : window.location.pathname;
        }

        // The page's render paths (RPI-1138) and the attributes the error or
        // the caller carries, under the keys above so they never replace one;
        // a failure here must never stop the report
        try {
          errinfo = Object.assign(
            { renderPaths: pageRenderPaths(), survey: segments },
            error.telemetryAttributes,
            attributes,
            errinfo
          );
        } catch (e) {}

        if (window.newrelic) {
          /**
           * New Relic's noticeError expects an Error object, so we need to
           * ensure we're passing one even if the original error is a string
           * or some other type.
           *
           * This cascades cleanly: prefer error.error if it's a real Error,
           * fall back to error itself if it is, and only construct a new one
           * as a last resort.
           */
          var errObj =
            error.error instanceof Error
              ? error.error
              : error instanceof Error
              ? error
              : new Error(error.message);

          newrelic.noticeError(errObj, errinfo);
        }
      }
    } catch (err) {}

    if (!window.is_production && window.console) {
      console.error(error);
    }

    if (silent) {
      // Don't inform the user.
      return;
    }

    const oopsTitle = __.localize('Oops! Something went wrong!');
    const oopsMessage = __.localize(
      'We sincerely apologize for the inconvenience. Please refresh your browser or check back later to resume your survey.'
    );

    if (error.status && error.status === 404) {
      document.title = '404 Page Not Found';
      var template = Gryphon.templates['404'];
      return $('#main_cont').html(template);
    }

    this.error(oopsTitle, oopsMessage, true);
  },
};

window.report = report;
